// eslint-disable-next-line no-unused-vars
import React from 'react'; 
import { withStyles } from '@material-ui/core/styles';

import CheckboxInputField from '../CheckboxInputField/.';

const styles = theme => ({
	root: {
	},
	appendedConfirmationPanel: {
		marginTop: "-4em",
	},
	panel: {
	    textAlign: "left",
	    color: "#959595",
	    backgroundColor: "#EEEFEF",
	    textShadow: "none",
	    marginTop: "1em",
	    marginBottom: "1em",
		fontFamily: "AIGFutura_Book",
	    padding: "2em 3em 1.5em",
	    [theme.breakpoints.down(769)]: {
	    	padding: "1em",
	    },
	},
	innerPanel: {
		paddingBottom: ".5rem",
	},
	checkboxInputFieldRC: {
	},
	declarationContainer: {
	},
	declarationTitle: {
	},
	declarationContent: {
		paddingBottom: ".5rem",
	    wordWrap: "break-word",
	},
});

interface PassInProperty{
	classes: any,
	onClick(checkedState: boolean): void,
	introduction: string,
	label: string,
	allowDangerouslySetInnerHTML: string,
	description: string,
	showCheckbox: boolean,
	isChecked: boolean,
	onLabelClick: any,
	declaration: string
}

@withStyles(styles)
class ConfirmationPanel extends React.Component<assInPropert> {
	
	render(){	
		const { 
			classes, 
			appendPanel,
			onClick,
			introduction,
			label,
			allowDangerouslySetInnerHTML,
			description,
			showCheckbox,
			isChecked,
			onLabelClick,
			declaration
		} = this.props;
			
		const loadCheckBox = !(showCheckbox == false);
		
		const onClickEvent = checkedState => {
			onClick(checkedState);
		}

		return (
			<div className={`${classes.root}` + (appendPanel ? ` ${classes.appendedConfirmationPanel}` : ``)}>
			
				<div className={classes.panel}>

					{introduction &&
						<div className={classes.panelIntroduction}>
							{allowDangerouslySetInnerHTML && allowDangerouslySetInnerHTML===true ? (
								<div dangerouslySetInnerHTML={{__html: introduction}} />
							) : (
								<div>
									{introduction}
								</div>
							)}
						</div>
					}
				
					<div className={classes.innerPanel}>
						{loadCheckBox && 
							<div>
								<CheckboxInputField
									className={classes.checkboxInputFieldRC}
									isChecked={isChecked}
									allowDangerouslySetInnerHTML={allowDangerouslySetInnerHTML}
									label={label}
									onClick={onClickEvent}
									onLabelClick={onLabelClick}
								/>
							</div>
							
						}
					</div>

					<div className={`${classes.declarationContainer} small`}>
						{description &&
							<div className={`${classes.declarationTitle}`}>
								<div onClick={onLabelClick} dangerouslySetInnerHTML={{__html: description}} />
							</div>
						}

						<div onClick={onLabelClick} className={`${classes.declarationContent}`}>
							{declaration}
						</div>
					</div>
				</div>
			
			</div>
		);
	}
}
export default ConfirmationPanel;